import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type WorkspacePayload = {
    websiteId?: string;
    placeId?: string;
    websiteName?: string;
    openModal?: boolean;
    baseWorkspaceUrl?: string;
    singleWebsite?: boolean;
    companyId?: string;
};

export type WorskpaceState = {
    websiteId: string;
    placeId: string;
    websiteName: string;
    openModal: boolean;
    baseWorkspaceUrl: string;
    singleWebsite: boolean;
    companyId?: string;
};

const initialState: WorskpaceState = {
    websiteId: '',
    placeId: '',
    websiteName: '',
    openModal: true,
    baseWorkspaceUrl: '',
    singleWebsite: false,
    companyId: '',
};

const workspaceSlice = createSlice({
    name: 'workspace',
    initialState,
    reducers: {
        resetWorkspace: () => {
            return initialState;
        },
        setWorkspace: (state, action: PayloadAction<WorkspacePayload>) => {
            return { ...state, ...action.payload };
        },
    },
    selectors: {
        selectWebsiteId: (state) => state.websiteId,
        selectPlaceId: (state) => state.placeId,
        selectWebsiteName: (state) => state.websiteName,
        selectOpenModal: (state) => state.openModal,
        selectBaseWorkspaceUrl: (state) => state.baseWorkspaceUrl,
        selectSingleWebsite: (state) => state.singleWebsite,
    },
});

export const { setWorkspace, resetWorkspace } = workspaceSlice.actions;
export const {
    selectPlaceId,
    selectWebsiteName,
    selectWebsiteId,
    selectOpenModal,
    selectBaseWorkspaceUrl,
    selectSingleWebsite,
} = workspaceSlice.selectors;
export default workspaceSlice.reducer;
